export default {
  all() {
    let res = {};
    for(let k in arguments){
      res = { ...res, ...arguments[k]}
    }
    return res;
  }
}
